module.exports = __webpack_public_path__ + "res/Roboto-Italic-webfont.ttf?4ae0b2f98fcf6d76a1eac1c638beff59";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Italic-webfont.ttf
// module id = 24
// module chunks = 0